import React , { useState, useEffect }  from "react";
import { Link } from "react-scroll";
import ReadMore from 'components/ui/Readmore';
import {LinkIcon} from 'components/icons/link-icon';
import {ArrowUp} from 'components/icons/arrow-up';
import {ArrowDown} from 'components/icons/arrow-down';
import { PlusIcon } from "@heroicons/react/solid";
import {useAuth} from 'contexts/provider/AuthProvider'
import { useNavigate } from "react-router-dom";
import {Links} from 'routes/PathLink'

import {formatINR , getWebsiteName ,formatINRWithSYm ,formatDateTime } from 'components/config/Common';
import {
  useCompanyDefaultRatioData ,
  useSaveFollowMutation
} from 'data/company';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaBriefcase, FaUsers } from "react-icons/fa";
import { MdFollowTheSigns } from "react-icons/md";
import {useIncreaseStockView, useStockStatQuery} from 'data/stock-stat-data'
import ShareSection from 'components/ui/sharesection.tsx';

export default function CompanyBasicSection({companyinfo,isFollowed}) {
  const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'));
  const {logout, isUser} = useAuth();
  let navigate = useNavigate();
  //const [isFollowed , setIsFollowed] = useState(false);
  //const id = companyinfo?.id;
  //console.log('id====',id)

  const {
        companydefaultratio,
        isLoading: loading,
        error:errorindicescomp,
        companymainLabelsList,
      } = useCompanyDefaultRatioData(companyinfo?.id);
   const company_basic_info = JSON.parse(companyinfo?.company_basic_info);

   const {mutate:increase_count} = useIncreaseStockView();
    
   const { mutate, isLoading } = useSaveFollowMutation();

   const {data:stockStat} = useStockStatQuery({id:companyinfo?.id})

   //console.log('stock stat=====', stockStat)

   //useSaveFollowMutation
   
    useEffect(() => {      
      updateViewCount(companyinfo?.id)
    }, [companyinfo]);

    const updateViewCount = (id) => {
      //console.log('id====>',id)
      increase_count(id)
    }

  const followStock = ()=>{
    if(isUser){
      mutate({
        id:companyinfo?.id,
      security_id: companyinfo?.id,
      action: isFollowed ? 'unfollow' : 'follow',
      access_token:access_token,
    });
    
    }else{
      navigate(`${Links.USER_LOGIN}`);
    }
  }
  const compactIN = (num) =>
    new Intl.NumberFormat('en-IN', {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 1,
  }).format(num);

  return (
      <section className="bg-white shadow-md z-50 rounded-xl p-5" id="top-ratios">
         <div className="flex flex-col lg:flex-row py-2 px-2 gap-x-6 ">
          <div className="w-full lg:w-2/3 gap-3 space-y-4">
              <div className="flex justify-between">
                <div>
                  <h1 className="text-heading">{companyinfo?.name}</h1>
                </div>
                <div>
                  <div className="flex gap-x-2">
                  <div className="text-xl text-heading">{companyinfo?.nse_price?
                  formatINRWithSYm(companyinfo?.nse_price,2)
                  :
                  null
                  }</div>
                   <div>
                    {companyinfo?.p_change && <>
                    {companyinfo?.p_change < 0?
                      (<div className="text-red-600 flex gap-x-2"><ArrowDown className="w-2 h-2" />{companyinfo?.p_change}%</div>)
                      :
                      (<div className="text-emerald-500 flex gap-x-2 "><ArrowUp className="w-2 h-2" />{companyinfo?.p_change}%</div>)
                      }
                      </>
                    }
                  </div>
                  </div>
                  <div className="text-sm" >{companyinfo?.price_updated_on?
                  formatDateTime(companyinfo?.price_updated_on)
                  :
                  null
                  }</div>
                </div>
              </div>
              <div className="flex space-x-10 items-center top-ratio-first-sec">
                <div className="font-normal">NSE: {companyinfo?.symbol}</div>
                <div className="font-normal">BSE: {companyinfo?.bse_code}</div>
                <div className="top-ratio-first-sec">
                  {company_basic_info?.website ?
                  <div className="flex gap-1 items-center">
                    <a
                    href={company_basic_info?.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-accent flex gap-1 items-center"
                  >
                    <LinkIcon className="w-6 h-6" fill="#18CB96" color="#18CB96"/>
                    {getWebsiteName(company_basic_info?.website)}
                  </a>
                  </div>
                  : companyinfo?.website_link ?
                  (<div>
                    <a
                    href={companyinfo?.website_link}
                    className="text-accent flex gap-1 items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkIcon className="w-6 h-6" fill="#18CB96" color="#18CB96"/>
                    {getWebsiteName(companyinfo?.website_link)}
                  </a>
                  </div>)
                  :null
                  }
                  </div>
                <div></div>
              </div>
              <div className="grid grid-cols-3 gap-4 border-[1px] rounded-xl px-4 py-6 ">
                 {Object.keys(companymainLabelsList || {}).length === 0 ? (
                  <div className="p-5 text-heading w-full"> Data is not ready yet , please check again
                </div>
                    ) : (<>
                {Object.entries(companymainLabelsList).map(([key, item],index) => {
                      const rowIndex = Math.floor(index / 3); // 👈 every 3 items = new row
                    return(<div key={index} className={`p-3 border-0 rounded flex justify-between ${rowIndex % 2 === 0 ? ' bg-white ' : ' bg-gray-50'}`}>
                      <div className=" ">{key}</div>
                      <div  >
                       <span className="">  {item?.prefix}</span> <span className="numbercss">{item?.is_format ? formatINR(item?.value,2): item?.value }</span><span className="text-gray-500 text-sm">  {item?.postfix}</span></div>
                    </div>)
                  })}
                  </>)}
              </div>
          </div>
          <div className="w-full lg:w-1/3  flex flex-1 flex-col company-profile">
             <div className="flex flex-row flex-wrap lg:flex-nowrap pb-6 gap-2 items-center mt-5 lg:mt-0">
                  {stockStat?.data?.viewCount ?
                  <button data-tooltip-id="view-tooltip" type="button" className="flex items-center gap-1 border border-accent py-1 px-3 rounded text-accent"
                  data-tooltip-html="<div class='w-48'>It shows how many times users have viewed the details about this company.</div>">
                    <FaUsers />
                    <div className="text-gray-600">{compactIN(stockStat?.data?.viewCount)}</div>
                  </button>
                  :null
                  }
                  {stockStat?.data?.followCount ?
                  <button data-tooltip-id="view-tooltip" type="button" className="flex items-center gap-1 border border-accent text-accent py-1 px-3 rounded"
                  data-tooltip-html="<div class='w-48'>It shows how many people are following this stock to track its performance.</div>">
                    <MdFollowTheSigns />
                    <div className="text-gray-600">{compactIN(stockStat?.data?.followCount)}</div>
                  </button>
                  :null
                  }
                  {stockStat?.data?.portfolioCount ?
                  <button data-tooltip-id="view-tooltip" type="button" className="flex items-center gap-1 border border-accent text-accent py-1 px-3 rounded"
                  data-tooltip-html="<div class='w-48'>It shows how many people have added this stock in their smart portfolio.</div>">
                    <FaBriefcase />
                    <div className="text-gray-600">{compactIN(stockStat?.data?.portfolioCount)}</div>
                  </button>
                  :null
                  }
                  <button type="button" onClick={followStock} class={`${isFollowed? "bg-gray-100  " : " bg-accent text-white "} text-heading  uppercase font-2xl font-semibold bg-accent box-border border border-transparent hover:bg-acent-strong  shadow-xs font-medium leading-5 rounded text-sm px-2 py-1.5 focus:outline-none flex gap-x-1 items-center`} > 
                    <PlusIcon className={`w-4 h-4 ${isFollowed ? '' : ' text-white '} text-body`} /> 
                    <div>Follow</div>
                  </button>
             </div>
             <div>
              <ReactTooltip
                id="view-tooltip"
                place="top"                
                style={{zIndex:99}}
              />
             </div>
             <div>
              <div>
                <ShareSection title={`${companyinfo?.name} Stock Analysis & Financial Data`} />
              </div>
              <h4 className="title text-heading pt-2 ">About</h4>
              <p className="text-base/80">
                <ReadMore
                text={companyinfo?.about}
                limit={240}
                companyinfo={companyinfo}
                />
                </p>
            </div>
          </div>
        </div>
      </section> 
  );
}
